import type { SiteName } from '@/scopes/common/domain/types'

/*
// !!! Do not concatenate, derive or reconstruct an IBAN using the values in this configurations
// They are only used for presentation in locales and must be filled in according to them. For example:
//  - transferBankNumber:
//        Primary payment number to use for the locale,
//        for NL/DE/BE is the IBAN, but just the account number in DK and UK. For SE is the Bankgiro number
//  - bankIdentifier in DK matches the one in IBAN, but not for UK which is the sort code.
*/
export interface BankTransferSiteDetails {
  // Mandatory. Primary payment identifier for the locale
  transferBankNumber: string
  // Optional. Recipient / Account holder name.
  beneficiaryName?: string
  // Optional. SWIFT/BIC code.
  bicCode?: string
  // Optional. Name of the bank.
  bankName?: string
  // Optional. Explicit identifier of the bank or routing entity. Examples: DK: Reg.number, UK: Sort code
  bankIdentifier?: string
  // Optional. Explicit IBAN value when available and required separately
  ibanNumber?: string
  // Mandatory. Limit of days before departure of booking in which bank transfer is allowed.
  allowedDaysBeforeDeparture: number
}

type BankTransferDetailsConfig = Partial<Record<SiteName, BankTransferSiteDetails>>

const BANK_TRANSFER_DETAILS: BankTransferDetailsConfig = {
  sunwebnl: { transferBankNumber: 'NL29 RABO 0356 3119 61', beneficiaryName: 'Sunweb  Postbus 1439  3000 BK ROTTERDAM', bankName: 'Rabobank', allowedDaysBeforeDeparture: 3 },
  sunwebbenl: { transferBankNumber: 'NL29 RABO 0356 3119 61', beneficiaryName: 'Sunweb Group Netherlands B.V', bicCode: 'RABONL2U', allowedDaysBeforeDeparture: 3 },
  sunwebbefr: { transferBankNumber: 'NL29 RABO 0356 3119 61', beneficiaryName: 'Sunweb Group Netherlands B.V', bicCode: 'RABONL2U', allowedDaysBeforeDeparture: 7 },
  // sunwebfr does not have banktransfer
  sunwebdk: { transferBankNumber: '1052696', bankName: 'Jyske Bank', bankIdentifier: '5078', bicCode: 'JYBADKKK', ibanNumber: 'DK9550780001052696', allowedDaysBeforeDeparture: 21 },
  sunwebse: { transferBankNumber: '545-3584', beneficiaryName: 'Sundio Sweden AB', bankName: 'Swedbank', allowedDaysBeforeDeparture: 21 },
  sunwebuk: { transferBankNumber: '21109768', beneficiaryName: 'Sunweb Holidays', bankIdentifier: '306541', allowedDaysBeforeDeparture: 7 },
  sunwebde: { transferBankNumber: 'NL89 RABO 0320 0049 45', beneficiaryName: 'Sunweb Group Germany GmbH', bankName: 'Rabobank', allowedDaysBeforeDeparture: 3 },
  elizanl: { transferBankNumber: 'NL18 RABO 0127 4824 66', beneficiaryName: 'Eliza was here, Postbus 1439, 3000 BK ROTTERDAM', bankName: 'Rabobank', allowedDaysBeforeDeparture: 3 },
  elizabe: { transferBankNumber: 'NL18 RABO 0127 4824 66', beneficiaryName: 'Sunweb Group Netherlands B.V', bicCode: 'RABONL2U', allowedDaysBeforeDeparture: 3 },
}

export function getBankTransferDetails(siteName: SiteName): BankTransferSiteDetails | null {
  return BANK_TRANSFER_DETAILS[siteName] ?? null
}
